// import React, { useState } from "react";
// import {
//     getDocs,
//     collection,
//     query,
//     where,
//     updateDoc,
//     doc
// } from "firebase/firestore";
// import db from "./Firebase";

// function FixDuplicateUsernames() {
//     const [logs, setLogs] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const log = (msg) => {
//         setLogs(prev => [...prev, msg]);
//     };

//     const runFixScript = async () => {
//         setLogs([]);
//         setLoading(true);

//         try {
//             // 1️⃣ Fetch all personal_details
//             const personalSnapshot = await getDocs(collection(db, "personal_details"));
//             const users = personalSnapshot.docs.map(d => ({
//                 id: d.id,
//                 ...d.data()
//             }));

//             // 2️⃣ Fetch all usernames in portfolio_details
//             const portfolioSnapshot = await getDocs(collection(db, "portfolio_details"));
//             const portfolioUsernames = new Set(
//                 portfolioSnapshot.docs.map(doc => doc.data().username)
//             );

//             // 3️⃣ Build used usernames from both collections
//             const usedUsernames = new Set([
//                 ...users.map(u => u.username),
//                 ...portfolioUsernames
//             ]);

//             // 4️⃣ Group by username
//             const grouped = {};
//             users.forEach(user => {
//                 if (!grouped[user.username]) {
//                     grouped[user.username] = [];
//                 }
//                 grouped[user.username].push(user);
//             });

//             // 5️⃣ Process duplicates only
//             for (const username in grouped) {
//                 const records = grouped[username];
//                 if (records.length === 1) {
//                     log(`✅ Skipped ${username} (unique)`);
//                     continue;
//                 }

//                 log(`🔁 Processing duplicates for "${username}"`);

//                 for (let i = 1; i < records.length; i++) {
//                     let counter = 1;
//                     let newUsername = "";

//                     while (true) {
//                         newUsername = `${username}${counter}`;
//                         if (!usedUsernames.has(newUsername)) break;
//                         counter++;
//                     }

//                     await updateDoc(
//                         doc(db, "personal_details", records[i].id),
//                         { username: newUsername }
//                     );

//                     usedUsernames.add(newUsername);
//                     log(`✏️ Updated ${username} → ${newUsername}`);
//                 }
//             }

//             log("✅ Username fixing completed");
//         } catch (error) {
//             log(`❌ Error: ${error.message}`);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="p-4">
//             <h4>Fix Duplicate Usernames</h4>
//             <button
//                 className="btn btn-primary btn-sm mb-3"
//                 onClick={runFixScript}
//                 disabled={loading}
//             >
//                 {loading ? "Processing..." : "Run Fix Script"}
//             </button>

//             <div className="log-box border p-3 bg-light" style={{ maxHeight: 400, overflowY: 'auto' }}>
//                 <h6>Logs:</h6>
//                 <ul className="small mb-0">
//                     {logs.map((log, index) => (
//                         <li key={index}>{log}</li>
//                     ))}
//                 </ul>
//             </div>
//         </div>
//     );
// }

// export default FixDuplicateUsernames;



// import React, { useState } from "react";
// import {
//     getDocs,
//     collection,
//     query,
//     where,
//     updateDoc,
//     doc
// } from "firebase/firestore";
// import db from "./Firebase";

// function FixDuplicateUsernames() {
//     const [logs, setLogs] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const log = (msg) => {
//         setLogs(prev => [...prev, msg]);
//     };

//     const runFixScript = async () => {
//         setLogs([]);
//         setLoading(true);

//         try {
//             const snapshot = await getDocs(collection(db, "personal_details"));
//             const users = snapshot.docs.map(d => ({
//                 id: d.id,
//                 ...d.data()
//             }));

//             const usedUsernames = new Set(users.map(u => u.username));

//             const grouped = {};
//             users.forEach(user => {
//                 if (!grouped[user.username]) {
//                     grouped[user.username] = [];
//                 }
//                 grouped[user.username].push(user);
//             });

//             for (const username in grouped) {
//                 const records = grouped[username];

//                 if (records.length === 1) {
//                     log(`✅ Skipped ${username} (unique)`);
//                     continue;
//                 }

//                 log(`🔁 Processing duplicates for "${username}"`);

//                 for (let i = 1; i < records.length; i++) {
//                     let counter = 1;
//                     let newUsername = "";

//                     while (true) {
//                         newUsername = `${username}${counter}`;

//                         const portfolioSnap = await getDocs(
//                             query(collection(db, "portfolio_details"), where("username", "==", newUsername))
//                         );

//                         if (portfolioSnap.empty && !usedUsernames.has(newUsername)) {
//                             break;
//                         }

//                         counter++;
//                     }

//                     await updateDoc(
//                         doc(db, "personal_details", records[i].id),
//                         { username: newUsername }
//                     );

//                     usedUsernames.add(newUsername);
//                     log(`✏️ Updated ${username} → ${newUsername}`);
//                 }
//             }

//             log("✅ Username fixing completed");
//         } catch (error) {
//             log(`❌ Error: ${error.message}`);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="p-4">
//             <h4>Fix Duplicate Usernames</h4>
//             <button
//                 className="btn btn-primary btn-sm mb-3"
//                 onClick={runFixScript}
//                 disabled={loading}
//             >
//                 {loading ? "Processing..." : "Run Fix Script"}
//             </button>

//             <div className="log-box border p-3 bg-light" style={{ maxHeight: 400, overflowY: 'auto' }}>
//                 <h6>Logs:</h6>
//                 <ul className="small mb-0">
//                     {logs.map((log, index) => (
//                         <li key={index}>{log}</li>
//                     ))}
//                 </ul>
//             </div>
//         </div>
//     );
// }

// export default FixDuplicateUsernames;


import React, { useEffect, useState } from "react";
import db from "./Firebase";
import { collection, getDocs } from "firebase/firestore";
import Moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function DuplicateUsernames() {
    const [duplicates, setDuplicates] = useState([]);
    const [uniqueCount, setUniqueCount] = useState(0);

    useEffect(() => {
        const fetchDuplicates = async () => {
            const snapshot = await getDocs(collection(db, "personal_details"));
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));

            const usernameCount = data.reduce((acc, curr) => {
                acc[curr.username] = (acc[curr.username] || 0) + 1;
                return acc;
            }, {});

            const duplicateUsernames = Object.keys(usernameCount).filter(
                (username) => usernameCount[username] > 1
            );

            const duplicateRecords = data
                .filter((item) => duplicateUsernames.includes(item.username))
                .sort((a, b) => a.username.localeCompare(b.username));

            setDuplicates(duplicateRecords);
            setUniqueCount(duplicateUsernames.length);
        };

        fetchDuplicates();
    }, []);

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(
            duplicates.map((item, index) => ({
                "Sr. No": index + 1,
                Username: item.username,
                "Full Name": item.full_name,
                "Created Date": Moment(item.created_date?.toDate()).format("YYYY-MM-DD HH:mm:ss")
            }))
        );

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Duplicate Usernames");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "Duplicate_Usernames.xlsx");
    };

    return (
        <div className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h4>Duplicate Usernames (Unique Count: {uniqueCount})</h4>
                <button className="btn btn-success btn-sm" onClick={exportToExcel}>
                    Download Excel
                </button>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Username</th>
                            <th>Full Name</th>
                            <th>Phone</th>
                            <th>Created Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {duplicates.map((item, index) => (
                            <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.username}</td>
                                <td>{item.full_name}</td>
                                <td>{item.phone_no}</td>
                                <td>{Moment(item.created_date?.toDate()).format("YYYY-MM-DD HH:mm:ss")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default DuplicateUsernames;


// // // import React, { useEffect, useState } from "react";
// // // import db from "./Firebase";
// // // import { collection, getDocs } from "firebase/firestore";
// // // import Moment from "moment";

// // // function DuplicateUsernames() {
// // //     const [duplicates, setDuplicates] = useState([]);
// // //     const [uniqueCount, setUniqueCount] = useState(0);

// // //     useEffect(() => {
// // //         const fetchDuplicates = async () => {
// // //             const snapshot = await getDocs(collection(db, "personal_details"));
// // //             const data = snapshot.docs.map((doc) => ({
// // //                 id: doc.id,
// // //                 ...doc.data()
// // //             }));

// // //             // Count how many times each username appears
// // //             const usernameCount = data.reduce((acc, curr) => {
// // //                 acc[curr.username] = (acc[curr.username] || 0) + 1;
// // //                 return acc;
// // //             }, {});

// // //             // Get usernames that appear more than once
// // //             const duplicateUsernames = Object.keys(usernameCount).filter(
// // //                 (username) => usernameCount[username] > 1
// // //             );

// // //             // Filter all records for those usernames
// // //             const duplicateRecords = data
// // //                 .filter((item) => duplicateUsernames.includes(item.username))
// // //                 .sort((a, b) => a.username.localeCompare(b.username));

// // //             setDuplicates(duplicateRecords);
// // //             setUniqueCount(duplicateUsernames.length);
// // //         };

// // //         fetchDuplicates();
// // //     }, []);

// // //     return (
// // //         <div className="p-3">
// // //             <h4>Duplicate Usernames (Unique Count: {uniqueCount})</h4>
// // //             <div className="table-responsive">
// // //                 <table className="table table-bordered table-striped">
// // //                     <thead>
// // //                         <tr>
// // //                             <th>#</th>
// // //                             <th>Username</th>
// // //                             <th>Full Name</th>
// // //                             <th>Created Date</th>
// // //                         </tr>
// // //                     </thead>
// // //                     <tbody>
// // //                         {duplicates.map((item, index) => (
// // //                             <tr key={item.id}>
// // //                                 <td>{index + 1}</td>
// // //                                 <td>{item.username}</td>
// // //                                 <td>{item.full_name}</td>
// // //                                 <td>{item.phone_no}</td>
// // //                                 <td>{Moment(item.created_date?.toDate()).format("YYYY-MM-DD HH:mm:ss")}</td>
// // //                             </tr>
// // //                         ))}
// // //                     </tbody>
// // //                 </table>
// // //             </div>
// // //         </div>
// // //     );
// // // }

// // // export default DuplicateUsernames;
